module.exports = __webpack_public_path__ + "img/main.md.6b9def9d.webp";